//import packages from node modules
import React from "react"
import PropTypes from 'prop-types'


const DomainConfigWarning = ({selectedProduct,order_type}) => {
    if(selectedProduct){
        const {attributes} = selectedProduct
        const {custom_fields, name} = attributes
        if (custom_fields && custom_fields.length > 0 && order_type==="register") {
            const renderLink = () =>{
                if(name && name.indexOf(".au")>=0){
                    return (<a className={'of-domain-config__warning-link primary-font-1-100'} href={'https://www.auda.org.au/policies/index-of-published-policies/2012/2012-04/'} target={'_blank'}>Read more about eligibility</a>)
                }
                return (<></>)
            }
            return (
                <div className={'of-domain-config__warning shades-secondary-background-1-100'}>
                    <div className={'of-domain-config__warning-wrapper'}>
                        <div className={'of-domain-config__warning-description text-font-3-100'}>
                            <strong className={'text-font-1-100'}>{name}</strong> domain names require eligibility in order to be registered. Please enter your eligibility information below.{renderLink()}
                        </div>
                    </div>
                </div>
            )
        }
    }
    return (<></>)
}

DomainConfigWarning.propTypes = {
    selectedProduct: PropTypes.object,
    order_type: PropTypes.string
}

export default DomainConfigWarning